<template>
    <div class="flex gap-2">
        <ButtonDefault @click="addFirma">Agregar Firma</ButtonDefault>
        <ButtonDefault v-if="firmas.filter(e => e.base64).length > 0" color="blue" @click="confirmarFirmas">Confirmar Firmas</ButtonDefault>
    </div>
    <div class="grid grid-cols-1 gap-2">
       <div v-for="(firma, index) in firmas" :key="index">
          <div class="border border-blue-600 bg-blue-50 rounded-md p-4 my-2">
              <div class=" flex justify-between">Firma #{{ index + 1 }}  <div><slot name="buttons" v-bind="{firma}"></slot><ButtonDefault color="red" size="xs" @click="firmas.splice(index, 1)"><TrashIcon class="h-6 w-6 text-red-500 cursor-pointer" /></ButtonDefault></div></div>
              <div class="grid grid-cols-3 my-2 gap-4">
                <div>
                  <SelectDefault v-model="firma.tipo" :options="listTiposFirmas" option-text="optionText" option-value="optionValue" @change="firma.base64 = ''" />
                  <InputDefault v-model="firma.nombre" placeholder="Nombre firmante" />
                  <InputDefault v-model="firma.identificacion" placeholder="Ident. firmante" />
                  <InputDefault v-model="firma.extraDetalle" placeholder="Pie firma" />
                </div>
                <div class="grid grid-cols-2 gap-2 col-span-2">
                  <div>
                      <div v-if="firma.tipo === 'Foto'">
                          <ButtonDefault v-if="firma.base64" color="blue" @click="firma.base64 = ''">Rehacer Foto</ButtonDefault>
                          <CameraDefault v-if="!firma.base64" :set-foto="(foto)=> firma.base64 = foto"/>
                      </div>
                      <div v-if="firma.tipo === 'Huella'">
                        <ButtonDefault v-if="firma.base64" color="blue" @click="firma.base64 = ''">Rehacer Huella</ButtonDefault>
                        <HuelleroDigitalPersonaDefault v-if="!firma.base64" :set-foto="(foto)=> firma.base64 = foto"/>
                      </div>
                      <div v-if="firma.tipo === 'Firma'">
                          <ButtonDefault v-if="firma.base64" color="blue" @click="firma.base64 = ''">Rehacer Firma</ButtonDefault>
                          <FirmaLienzoDefault v-if="!firma.base64" :set-foto="(foto)=> firma.base64 = foto"/>
                      </div>
                  </div>
                  <template v-if="firma.base64">
                      <img v-if="firma.tipo === 'Firma'" class="h-20 w-30" :src="firma.base64" alt="Firma" />
                      <img v-else class="h-20 w-20" :src="firma.base64" alt="Firma" />
                  </template>
                </div>
              </div>
          </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';
import type { IDocumentoFirma } from '../../interfaces/IDocumento'
import { TrashIcon } from '@heroicons/vue/24/outline'
import CameraDefault from '@/modules/Core/components/Media/CameraDefault.vue'
import ButtonDefault from '@/modules/Core/components/general/ButtonDefault.vue'
import FirmaLienzoDefault from '@/modules/Core/components/Media/FirmaLienzoDefault.vue'
import type { TDocumentDefinitions } from 'pdfmake/interfaces'
import HuelleroDigitalPersonaDefault from '@/modules/Core/components/Media/HuelleroDigitalPersonaDefault.vue'
const { setFirmas } = defineProps<{
  setFirmas: (firmas: TDocumentDefinitions['content'], images: TDocumentDefinitions['images'], columnas: unknown[]) => void
}>()
defineSlots<{
  buttons: (item: { firma: IDocumentoFirma }) => unknown
}>()
const listTiposFirmas = [
    { optionValue: 'Firma', optionText: 'Firma' },
    { optionValue: 'Foto', optionText: 'Foto' },
    { optionValue: 'Huella', optionText: 'Huella' }
]
const buildFirmasDocDefinition = (columnas: unknown[]) => ([
    {
        text: 'Firmas',
        style: 'h2',
        margin: [0, 30, 0, 0]
    },
    {
        columns: columnas,
        columnGap: 5,
        margin: [
            0,
            0,
            0,
            12
        ]
    }
] as TDocumentDefinitions['content']);
const firmas = ref<IDocumentoFirma[]>([])
const addFirma = () => {
    firmas.value.push({
        tipo: 'Firma',
        base64: '',
        nombre: '',
        identificacion: '',
        extraDetalle: ''
    })
}
const confirmarFirmas = () => {
    let images = {}
    const columnas = firmas.value.filter(e => e.base64).map((firma, i) => {
        const stack = [] as TDocumentDefinitions['content'][];
        images = { ...images, ['FIRMA_'+i]: firma.base64}
        stack.push({
            image: 'FIRMA_'+i,
            width: firma.tipo === 'Firma' ? 90 : 60,
            height: firma.tipo === 'Firma' ? 60 : 60,
            margin: [0, 10, 0, 0]
        })
        if(firma.nombre) stack.push({ text: firma.nombre });
        if(firma.identificacion) stack.push({ text: firma.identificacion });
        if(firma.extraDetalle) stack.push({ text: firma.extraDetalle });
        return {
            stack
        }
    }) as unknown[]
    setFirmas(buildFirmasDocDefinition(columnas), images, columnas);
}

</script>
